import { Component, inject, OnInit } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormArray,
  AbstractControl
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseClientComponent } from './base-client.component';
import { BaseComponent } from './base.component';

@Component({
  selector: 'lib-base-payroll',
  template: '',
  standalone: false
})
export class BasePayrollComponent extends BaseClientComponent implements OnInit {
  public year: number;
  public seqNo: number;

  constructor() {
    super();
    this.year = +this.route.snapshot.paramMap.get('year');
    this.seqNo = +this.route.snapshot.paramMap.get('seqNo');
  }

  ngOnInit() {}

  public checkNumberDisplay(checkNo: string) {
    if (!checkNo) {
      return '';
    }

    // expect system generated check numbers to be prefixed
    // with either C_ (check) or V_ (voucher).
    // replace prefix with either "Check" or "Voucher"
    // followed by the remaining characters
    if (checkNo.slice(0, 2) === 'C_') {
      return `Check ${checkNo.slice(2)}`;
    } else if (checkNo.slice(0, 2) === 'V_') {
      return `Voucher ${checkNo.slice(2)}`;
    } else {
      // user entered check numbers likely won't have these prefixes.
      // display those as they have been entered
      return checkNo;
    }
  }
}
